import { defineMessages } from 'react-intl';

export default defineMessages({
  checkAutoExpress: {
    id: 'check_auto_express.title',
  },
  subTitle: {
    id: 'check_auto_express.sub_title',
  },
  firstDescription: {
    id: 'check_auto_express.first_description',
  },
  thirdDescription: {
    id: 'check_auto_express.third_description',
  },
  secondDescription: {
    id: 'check_auto_express.second_description',
  },
  firstStep: {
    id: 'check_auto_express.first_step',
  },
  secondStep: {
    id: 'check_auto_express.second_step',
  },
  thirdStep: {
    id: 'check_auto_express.third_step',
  },
  alerteMobileTitle: {
    id: 'alerte_mobile.title',
  },
  alerteMobileDescription: {
    id: 'alerte_mobile.description',
  },
  expertiseDistanceTitle: {
    id: 'expertise_distance.title',
  },
  expertiseDistanceDescription: {
    id: 'expertise_distance.description',
  },
  garageAgreeTitle: {
    id: 'garages_agrees.title',
  },
  garageAgreeDescription: {
    id: 'garages_agrees.description',
  },
});
